import { RootState } from '@Store/index';
import { getRequisitionStatusesDictSelector } from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { createSelector } from '@reduxjs/toolkit';

const materialRequest = (state: RootState) =>
  state.featureStores.materialRequest;

const currentMaterialManagest = createSelector(
  materialRequest,
  ({ materialManagest }) => materialManagest
);

const currentMaterialRequest = createSelector(
  materialRequest,
  ({ materialRequest }) => materialRequest
);

const currentMaterialHeaderRequest = createSelector(
  materialRequest,
  ({ materialHeaderInfo }) => materialHeaderInfo
);

const mrSelectAllManagerSelector = createSelector(
  materialRequest,
  ({ mrSelectAllManager }) => mrSelectAllManager
);

const mrSearchManagerSelector = createSelector(
  materialRequest,
  ({ mrSearchManager }) => mrSearchManager
);

const materialRequestCreateRequisitionInfo = createSelector(
  [currentMaterialRequest, getRequisitionStatusesDictSelector],
  (materialRequest, statuses) => {
    const requisitionInfo = prepareRequisitionInfo(
      materialRequest,
      statuses,
      'MR'
    );
    return requisitionInfo;
  }
);

const modalManagerSettings = createSelector(
  materialRequest,
  ({ modalManager }) => modalManager
);

export const getStatusLabels = createSelector(
  getRequisitionStatusesDictSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);

const modalManager = createSelector(
  materialRequest,
  ({ modalManager }) => modalManager
);

const isButtonDisable = createSelector(
  materialRequest,
  ({ modalButtonDisable }) => modalButtonDisable
);

const modalManagerItem = createSelector(
  materialRequest,
  ({ modalManagerItem }) => modalManagerItem
);

const materialStoreOverhead = createSelector(
  materialRequest,
  ({ materialStoreOverhead }) => materialStoreOverhead
);

const materialCostCenters = createSelector(
  materialRequest,
  ({ materialCostCenters }) => materialCostCenters
);

const currentMaterialItemInputs = createSelector(
  materialRequest,
  ({ materialItemInputs }) => materialItemInputs
);

const comparisonSheetOffersSelector = createSelector(
  materialRequest,
  ({ comparisonSheetOffers }) => comparisonSheetOffers
);

const comparisonSheetSuppliersSelector = createSelector(
  materialRequest,
  ({ comparisonSheetSuppliers }) => comparisonSheetSuppliers
);

export {
  materialRequest,
  currentMaterialManagest,
  currentMaterialRequest,
  currentMaterialHeaderRequest,
  materialRequestCreateRequisitionInfo,
  modalManagerSettings,
  modalManager,
  modalManagerItem,
  materialCostCenters,
  mrSelectAllManagerSelector,
  currentMaterialItemInputs,
  mrSearchManagerSelector,
  materialStoreOverhead,
  comparisonSheetOffersSelector,
  comparisonSheetSuppliersSelector,
  isButtonDisable,
};
